var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuperFolderOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.96,9.26l-3,11-.26,.44-1,1-.71,.29H2l-.71-.29-1-1-.29-.71V4l.29-.71,1-1,.71-.29H7l.71,.29,1,1,.29,.71h10l.71,.29,1,1,.29,.71v1h-2v-.59l-.41-.41H7v-1.59l-.41-.41H2.41l-.41,.41v15.17l.06,.06,2.97-10.91,.96-.74H23l.96,1.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuperFolderOpen);
export default __webpack_public_path__ + "static/1776335122/media/icon-super-folder-open.0bbd2a53670db58074a19d98fe102424.svg";
export { ForwardRef as ReactComponent };